/**
 * Runtime copy that non-React code (e.g. API interceptors) can read.
 * BrandProvider sets these when the manifest loads.
 */

export const DEFAULT_SESSION_EXPIRED_MESSAGE =
  'Your session has expired. Please log in again. Redirecting to sign in page...';

let sessionExpiredMessage = DEFAULT_SESSION_EXPIRED_MESSAGE;

export function setSessionExpiredMessage(message: string): void {
  sessionExpiredMessage = message || DEFAULT_SESSION_EXPIRED_MESSAGE;
}

export function getSessionExpiredMessage(): string {
  return sessionExpiredMessage;
}
